import { batch, signal } from "@preact/signals-react"

export const tableData = signal([])
export const formData = signal({})
export const loadingRow = signal(null)

// Filters
export const isLoadingAdminBrands = signal(true)

// Merge
export const selectedBrandIds = signal([])
export const isMergeModalOpen = signal(false)
export const targetBrandId = signal(null)
export const isMerging = signal(false)
export const mergeResult = signal(null)

export const clearAdminBrandsSignals = () => batch(() => {
    tableData.value = []
    formData.value = {}
    loadingRow.value = null
    isLoadingAdminBrands.value = true
    selectedBrandIds.value = []
    isMergeModalOpen.value = false
    targetBrandId.value = null
    isMerging.value = false
    mergeResult.value = null
})
